import { render } from "./InputCheck.vue?vue&type=template&id=5d640628&ts=true"
import script from "./InputCheck.vue?vue&type=script&lang=ts"
export * from "./InputCheck.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__